/* eslint-disable */
import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { handleUrl } from './components/handleOpenMultipay';
import { Acl } from 'modules/common/components/Acl';
import * as action from './actions';
import * as c from './constants';
import { get, getJson } from 'session';
import WalletSupportTableContainer from './components/WalletSupportTableContainer'
import CashoutModal from './modals/CashoutModal';
import { ModalContext } from 'App';

function EWalletSupportContainer({
  findWallet,
  searching,
  history,
  permissions,
}) {
  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState({});

  const [walletBreakDown, setWalletBreakDown] = useState({})
  const [taxPayers, setTaxPayers] = useState({})
  const [walletTransaction, setWalletTransaction] = useState([])

  const [walletInfo, setWalletInfo] = useState({});
  const [taxPayerInfo, setTaxPayerInfo] = useState({});
  const [transId, setTransId] = useState({});

  const onFindWallet = (e) => {
    e.preventDefault();

    findWallet(formData, res => {
      const taxPayerData = _.get(res, 'res.res.included');

      // function that filters include.type
      const filterWalletType = (type, value) => type.filter(data => data.type === value)

      // separates include.type into different states
      setWalletBreakDown(filterWalletType(taxPayerData, 'wallet_breakdowns') || {});
      setTaxPayers(filterWalletType(taxPayerData, 'taxpayers') || {})
      setWalletTransaction(filterWalletType(taxPayerData, 'wallet_transactions') || {})

      setTransId(_.get(res, 'res.data.id'));
      setWalletInfo(_.get(res, 'res.data.attributes') || {});
      //includes
      setTaxPayerInfo(_.get(res, 'res.res.included') || {});
    });

    history.push('/wallet-support/wallet-history');
  };

  const handleClear = e => {
    e.preventDefault();
    setFormData({
      mobile_number: '',
    });
    setWalletInfo('');
  }

  const handleChange = e => {
    if (_.get(formData, 'mobile_number') === e.target.value) {
      setFormData({
        mobile_number: '',
      });
      setWalletInfo('');
    }
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onReloadCashOut = () => {
    // e.preventDefault();

    setWalletInfo('');

    findWallet(formData, res => {
      const taxPayerData = _.get(res, 'res.res.included');

      // function that filters include.type
      const filterWalletType = (type, value) => type.filter(data => data.type === value)

      // separates include.type into different states
      setWalletBreakDown(filterWalletType(taxPayerData, 'wallet_breakdowns') || {});
      setTaxPayers(filterWalletType(taxPayerData, 'taxpayers') || {})
      setWalletTransaction(filterWalletType(taxPayerData, 'wallet_transactions') || {})

      setTransId(_.get(res, 'res.data.id'));
      setWalletInfo(_.get(res, 'res.data.attributes') || {});
      //includes
      setTaxPayerInfo(_.get(res, 'res.res.included') || {});
    });

    history.push('/wallet-support/wallet-history');
  };

  const handleCashOut = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CashoutModal mobileNo={_.get(formData, 'mobile_number')} onReloadCashOut={onReloadCashOut} />,
      title: 'Request Cashout',
      modalSize: 'modal-sm',
    });
  };

  return (
    <div className="wallet-support pb-4 mx-4">
      <div className="container">
        <form
          onSubmit={onFindWallet}
          className="form-inline my-2 my-lg-0 d-flex justify-content-center"
        >
          <div className="mt-3 input-group mb-3 col-md-6 payments__form-bg">
            <div className="input-group-prepend">
              <label className="wallet-support__number-icon">#</label>
            </div>
            <input
              name="mobile_number"
              onChange={handleChange}
              value={_.get(formData, 'mobile_number') || ''}
              required
              type="text"
              style={{ border: 'none', marginRight: '10px' }}
              className="form-control"
              placeholder="Enter MOBILE NO (ex. 639XXXXXXXXX)"
              aria-describedby="basic-addon2"
            />
            {
              _.isEmpty(walletInfo) && (
                <div className="input-group-append">
                  <button
                    disabled={searching}
                    type="submit"
                    className="mr-3 btn btn-primary cms-bg-color-primary cms-outline-primary "
                  >
                    {searching ? (
                      <i className="fa fa-spin fa-spinner" />
                    ) : (
                      <>
                        Verify <i className="fa fa-check" />
                      </>
                    )}
                  </button>
                </div>
              )}
            {!_.isEmpty(walletInfo) && (
              <div className='input-group-append'>
                <button
                  onClick={handleClear}
                  type="submit"
                  className="mr-3 btn btn-danger"
                >
                  CLEAR <i className="fas fa-times" />
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
      {/*  payment summary (transaction summary in UI) */}
      {!_.isEmpty(walletInfo) && (
        <div className="wallet-support__summary container-fluid">
          <div className="wallet-support__summary-title"> WALLET TRANSACTION INFO </div>
          <hr className="stiches" />
          <table className="table borderless">
            <tbody>
              <tr>
                <td>
                  <b>Type:</b>
                </td>
                <td>{_.get(taxPayers[0], 'type') || 'N/A'}</td>
                <td>
                  <b>Full Name:</b>
                </td>
                <td>{_.get(taxPayers[0].attributes, '_full_name') || 'N/A'}</td>
              </tr>
              <tr>
              </tr>
              <tr>
                <td>
                  <b>Email:</b>
                </td>
                <td>{_.get(taxPayers[0].attributes, 'email') || 'N/A'}</td>
                <td>
                  <b>Contact Number:</b>
                </td>
                <td>{`+${_.get(taxPayers[0].attributes, 'mobile_number')}` || 'N/A'}</td>
              </tr>
              <tr>
                <td>
                  <b>Remaining Balance:</b>
                </td>
                <td>
                  <b>{_.get(walletInfo, 'remaining_balance') || 'N/A'}</b>
                </td>
                {Acl(permissions, [
                  'E-WALLET SUPPORT CASH OUT',
                ]) && (
                    <>
                      <td>
                        <>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleCashOut}
                          >
                            <b>Request Cash Out</b>
                          </button>
                        </>
                      </td>
                    </>
                  )}

              </tr>
            </tbody>
          </table>
          <div className="for-posting-wrap wallet-support-button-container">
          </div>
          <div className="multipay">
            <button
              type="button"
              className="btn btn-outline-primary w-100 mb-2"
              onClick={() => {
                handleUrl('https://inquiry.multipay.ph');
              }}
            >
              <b>Open Multipay</b>
            </button>
          </div>
          <hr />
          <WalletSupportTableContainer
            walletTransaction={walletTransaction}
            walletBreakDown={walletBreakDown}
            mobileNumber={formData}
            setFormData={setFormData}
            formData={formData}
            transId={transId}
            onClear={handleClear}
          />
        </div>
      )}
    </div>
  );
}

EWalletSupportContainer.propTypes = {
  findWallet: PropTypes.instanceOf(Function).isRequired,
  searching: PropTypes.bool.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  searching: api.loading.indexOf(c.FIND_WALLET) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(EWalletSupportContainer);